var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.00001C0 7.18571 0.0831737 7.34386 0.233445 7.48351L7.4975 13.8064C7.63251 13.9355 7.81576 14 8.02229 14C8.43257 14 8.75 13.7199 8.75 13.3431C8.75 13.1599 8.67045 13.0018 8.53904 12.8759L1.79337 7.00001L8.53904 1.1241C8.67045 0.998227 8.75 0.832822 8.75 0.656899C8.75 0.280026 8.43257 0 8.02229 0C7.81576 0 7.63251 0.0645648 7.4975 0.193694L0.233445 6.51651C0.0831737 6.65615 0 6.8143 0 7.00001Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArr);
export default __webpack_public_path__ + "static/media/left-arr.453bcec2b60b726928a2311569f9ec1f.svg";
export { ForwardRef as ReactComponent };